<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {},
        methods: {
            handleClick() {
                this.$router.push('/meeting');
            }

        }
    }

</script>

<style lang="scss">
    @import "~@/global.scss";
</style>
